const map = {
	"./css.js": "./src/editor/modes/css.js",
	"./cypher-editor.js": "./src/editor/modes/cypher-editor.js",
	"./cypher.js": "./src/editor/modes/cypher.js",
	"./html.js": "./src/editor/modes/html.js",
	"./markdown.js": "./src/editor/modes/markdown.js",
	"./rich-text-editor.js": "./src/editor/modes/rich-text-editor.js",
	"./rich-text.js": "./src/editor/modes/rich-text.js",
	"./sparql.js": "./src/editor/modes/sparql.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/editor/modes sync recursive ^\\.\\/.*\\.js$";